import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    text: "Finally found stuff to do around me without scrolling Instagram for an hour.",
    author: "Sarah M.",
    location: "Brooklyn, NY",
    rating: 5
  },
  {
    text: "It's like the sidewalk became digital. Super helpful.",
    author: "Mike R.",
    location: "Austin, TX",
    rating: 5
  },
  {
    text: "I've discovered so many local gems I never knew existed. Love supporting small businesses through this app!",
    author: "Jenny L.",
    location: "Portland, OR",
    rating: 5
  }
];

export function TestimonialsSection() {
  return (
    <section className="py-20 bg-transparent">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="font-poppins text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What people are saying about{' '}
            <span className="text-locale-primary">Locale</span>
          </h2>
          <p className="text-lg text-gray-600">
            Join thousands of people rediscovering their communities
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center mb-4">
                <Quote className="w-8 h-8 text-locale-primary/20 mr-2" />
                <div className="flex">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" />
                  ))}
                </div>
              </div>
              
              <p className="text-gray-700 mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>
              
              <div className="border-t border-gray-100 pt-4">
                <p className="font-poppins font-semibold text-gray-900">
                  {testimonial.author}
                </p>
                <p className="text-sm text-gray-500">
                  {testimonial.location}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}